import type { IconProps } from './types'

export const ManualIcon = ({ className }: IconProps) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <path
        d="M5.75 5.5C5.75 4.53 6.53 3.75 7.5 3.75H16.5C17.47 3.75 18.25 4.53 18.25 5.5V19.5C18.25 20.05 17.8 20.5 17.25 20.5H7.5C6.53 20.5 5.75 19.72 5.75 18.75V5.5Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path d="M5.75 18.75C5.75 17.78 6.53 17 7.5 17H18.25" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <line x1="9" y1="8" x2="15" y2="8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <line x1="9" y1="11" x2="15" y2="11" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  )
}
